import CryptoJS from 'crypto-js';
import * as Config from './config';
import * as Debug from './debug';

const aes_secret = Config.CRYPTO.AES_SECRET;

export const encTypes = 
{
    Hex: CryptoJS.enc.Hex,
    Latin1: CryptoJS.enc.Latin1,
    Utf8: CryptoJS.enc.Utf8,
    Utf16: CryptoJS.enc.Utf16,
    Utf16BE: CryptoJS.enc.Utf16BE,
    Utf16LE: CryptoJS.enc.Utf16LE,
    Base64: CryptoJS.enc.Base64,
}

export const MD5 = (str, enc = encTypes.Hex) =>
{
    return CryptoJS.MD5(str).toString(enc);
};

export const SHA1 = (str, enc = encTypes.Hex) =>
{
    return CryptoJS.SHA1(str).toString(enc);
};

export const SHA256 = (str, enc = encTypes.Hex) =>
{    
    return CryptoJS.SHA256(str).toString(enc);
};

export const SHA512 = (str, enc = encTypes.Hex) =>
{
    return CryptoJS.SHA512(str).toString(enc);
};

export const SHA3 = (str, outLength = 512, enc = encTypes.Hex) =>
{
    return CryptoJS.SHA3(str, { outputLength: outLength }).toString(enc);
};

export const RIPEMD160 = (str, enc = encTypes.Hex) =>
{
    return CryptoJS.RIPEMD160(str).toString(enc);
};


export const AES = class
{
    static encrypt(str, key = aes_secret)
    {
        return CryptoJS.AES.encrypt(str, key).toString();
    }

    static decrypt(str, key = aes_secret, dec = encTypes.Utf8)
    {
        let decrypted = CryptoJS.AES.decrypt(str, key);

        return decrypted.toString(dec);
    }
}

export const SHAAES = class
{
    static ivDefault = Config.CRYPTO.SHAAES_IV;

    static encrypt(str, key = aes_secret, iv = null)
    {
        let keyAes = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(key));

        return CryptoJS.AES.encrypt(str, keyAes, { iv: CryptoJS.enc.Hex.parse(iv ? iv : this.ivDefault) }).toString();
    }
    
    static decrypt(str, key = aes_secret, iv = null)
    {
        let keyAes = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(key));

        return CryptoJS.AES.decrypt(str, keyAes, { iv: CryptoJS.enc.Hex.parse(iv ? iv : this.ivDefault) }).toString(CryptoJS.enc.Utf8);
    }

    static encryptObject(obj, key = aes_secret)
    {
        if(obj == null)
            return null;

        if(key == "")
        {
            return obj;
        }

        if(typeof obj == 'string')
        {
            return this.encrypt(obj, key);
        }

        let objNew = {};

        try 
        {
            for(let keyCur in obj)
            {
                objNew[keyCur] = typeof obj[keyCur] == 'string' ? this.encrypt(obj[keyCur], key) : this.encryptObject(obj[keyCur], key);
            }
        } 
        catch (e) 
        {
            Debug.exception(e);
        }   

        return objNew;
    }

    static decryptObject(obj, key = aes_secret)
    {
        if(obj == null)
            return null;

        if(key == "")
        {
            return obj;
        }

        if(typeof obj == 'string')
        {
            return this.decrypt(obj, key);
        }

        let objNew = {};

        try 
        {
            for(let keyCur in obj)
            {
                objNew[keyCur] = typeof obj[keyCur] == 'string' ? this.decrypt(obj[keyCur], key) : this.decryptObject(obj[keyCur], key);
            }
        } 
        catch (e) 
        {
            Debug.exception(e);
        }   

        return objNew;
    }
}
